import './styles.css';
import { loadInitialState, maybeMountEditEntry, renderViewer } from './viewer';
import { verifySecret } from './api';
import { getSavedSecret, saveSecret, clearSavedSecret } from './auth-storage';

function isEditRoute(): boolean {
  const path = window.location.pathname;
  return path === '/edit' || path === '/edit/';
}

function removeLoading(): void {
  document.getElementById('app-loading')?.remove();
}

async function bootstrap(): Promise<void> {
  if (isEditRoute()) {
    await bootstrapEdit();
    return;
  }

  const state = await loadInitialState();
  await renderViewer(state);
  removeLoading();
  void maybeMountEditEntry();
}

async function bootstrapEdit(): Promise<void> {
  const statePromise = loadInitialState();
  const secret = await resolveSecret();
  const state = await statePromise;
  removeLoading();

  const { enterEditMode } = await import('./editor');
  enterEditMode(secret, state);
}

async function resolveSecret(): Promise<string> {
  const saved = getSavedSecret();
  if (saved !== null) {
    const result = await verifySecret(saved);
    // 仅 invalid 才证明密码确实失效；rate-limited / error 时无法判定，先信任本地缓存，
    // 让用户进编辑模式，真要存不上去再说（避免限流期间被静默踢回登录页）
    if (result !== 'invalid') {
      return saved;
    }
    clearSavedSecret();
  }

  removeLoading();
  const { showLogin } = await import('./login');
  const { secret, remember } = await showLogin();
  if (remember) {
    saveSecret(secret);
  } else {
    clearSavedSecret();
  }
  return secret;
}

bootstrap().catch((err: unknown) => {
  console.error('bootstrap failed', err);
  removeLoading();
  const article = document.getElementById('content');
  if (article) {
    article.hidden = false;
    article.textContent = '加载失败，请刷新或稍后再试。';
  }
});
